import React, {
  useState, useEffect, useCallback, useContext,
} from 'react';

import { GameContext } from '../../context/GameContext';
import { getArrow, ArrowCell } from './getArrow';

import {
  Container,
  Touch,
  InputValue,
  Arrow,
  ArrowCurvedBottom,
  ArrowCurvedUp,
  ArrowBottom,
  ArrowCurvedRight,
  ArrowCurvedLeft,
  Divisor,
  DicaInternaContainer,
  DicaInternaTexto,
} from './styles';

import arrowCurved from '../../../../assets/img/crosswords/arrow_curved.png';
import arrowCurvedLeft from '../../../../assets/img/crosswords/arrow_curved_left.png';
import arrowCurvedRight from '../../../../assets/img/crosswords/arrow_curved_right.png';
import arrow from '../../../../assets/img/crosswords/arrow.png';

interface iDicaInterna {
  id: number,
  direcao: number,
  x: number,
  y: number,
  texto: string,
  indice: number
}

interface iHouseProps {
  x: number,
  y: number,
  houseSize: number,
  direct: boolean,
}


const House: React.FC<iHouseProps> = ({ x, y, houseSize, direct }) => {

  const {
    state: { GameState, GameTemplate },
    dispatch,
  } = useContext(GameContext);

  const zoomScale = 2;

  const onPressHouse = useCallback(() => {
    //If doble press call change orientaion
    if (GameState.focusedHouse.row === x && GameState.focusedHouse.column === y) {
      dispatch({
        type: 'CHANGE_ORIENTATION',
        payload: {
          column: y,
          row: x,
        }
      });
    } else {
      dispatch({
        type: 'SET_CURRENT_HOUSE',
        payload: {
          column: y,
          row: x,
        },
      });
    }
  }, [x, y]);

  const handleCluePress = useCallback(() => {
    //dispatch(handleDirectsClick(GameTemplate.matrix[x][y]));
    dispatch({
      type: 'CLUE_HOUSE_CLICK',
      payload: {
        house: GameTemplate.matrix[x][y],
        column: y,
        row: x,
      },
    });
  }, []);
  // useEffect(() => {
  //   console.log('render');
  // }, []);
  if (GameTemplate.matrix[x][y].letra === '') {
    if (!direct) {
      return (
        <Container
          isDeadHouse={true}
          houseSize={houseSize}
          isTransparent
        />
      );
    }

    const arrowDirection = getArrow(GameTemplate.matrix[x][y] as unknown as ArrowCell, x, y);
    //console.log("arrowDirection;"+arrowDirection)
    var arrowDirectionSlited = [''];
    var firstArrowDirection = '';
    var secondArrowDirection = '';
    if (arrowDirection) {
      arrowDirectionSlited = arrowDirection.split(' ');
      firstArrowDirection = arrowDirectionSlited[0];
      secondArrowDirection = arrowDirectionSlited[1];
    }



    // If you don't have a second word
    if (GameTemplate.matrix[x][y].palavra_2 === -1) {
      return (
        <div onClick={handleCluePress}>

          <Container
            isDeadHouse={true}
            houseSize={houseSize}
            isTransparent
          >
            <DicaInternaContainer >
              <DicaInternaTexto zoom={zoomScale} >
                {GameTemplate.matrix[x][y].palavra_1.direcao === 0 &&
                  GameTemplate.chaves.horizontal[GameTemplate.matrix[x][y].palavra_1?.id.toString()][0]?.chave}
                {GameTemplate.matrix[x][y].palavra_1.direcao === 1 &&
                  GameTemplate.chaves.vertical[GameTemplate.matrix[x][y].palavra_1?.id.toString()][0]?.chave}
              </DicaInternaTexto>
            </DicaInternaContainer>
            {firstArrowDirection === 'curved_arrow_left' && <ArrowCurvedRight onClick={handleCluePress} src={`${arrowCurvedRight}`} alt="" />}
            {firstArrowDirection === 'arrow_bottom' && <ArrowBottom onClick={handleCluePress} src={`${arrow}`} />}
            {firstArrowDirection === 'curved_arrow_bottom' && <ArrowCurvedBottom onClick={handleCluePress} src={`${arrowCurved}`} />}
            {firstArrowDirection === 'arrow_left' && <Arrow onClick={handleCluePress} src={`${arrow}`} />}
            {firstArrowDirection === 'arrow_left_cima' && <ArrowCurvedUp onClick={handleCluePress} src={`${arrowCurvedRight}`} />}
            {firstArrowDirection === 'arrow_bottom_lado' && <ArrowCurvedLeft onClick={handleCluePress} src={`${arrowCurvedLeft}`} />}
            {firstArrowDirection === 'curved_arrow_back' && <ArrowCurvedLeft onClick={handleCluePress} src={`${arrowCurvedLeft}`} />}

          </Container>
        </div>

      );
    } if (GameTemplate.matrix[x][y].palavra_1 !== -1) {


      return (
        <div onClick={handleCluePress}>

          <Container
            isDeadHouse={true}
            houseSize={houseSize}
            isTransparent
          >
            {GameTemplate.matrix[x][y].palavra_1.direcao === 0 && GameTemplate.matrix[x][y].palavra_2.direcao === 0
              && (
                <>
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.horizontal[GameTemplate.matrix[x][y].palavra_1.id.toString()][0].chave}
                    </DicaInternaTexto>
                  </DicaInternaContainer>
                  <Divisor />
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.horizontal[GameTemplate.matrix[x][y].palavra_2.id.toString()][0].chave}
                    </DicaInternaTexto>
                  </DicaInternaContainer>
                </>
              )}

            {GameTemplate.matrix[x][y].palavra_1.direcao === 0 && GameTemplate.matrix[x][y].palavra_1.direcao === 1
              && (
                <>
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.horizontal[GameTemplate.matrix[x][y].palavra_1.id.toString()][0].chave}
                    </DicaInternaTexto>
                  </DicaInternaContainer>
                  <Divisor />
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.vertical[GameTemplate.matrix[x][y].palavra_1.id.toString()][0].chave}

                    </DicaInternaTexto>
                  </DicaInternaContainer>
                </>
              )}

            {GameTemplate.matrix[x][y].palavra_1.direcao === 0 && GameTemplate.matrix[x][y].palavra_2.direcao === 1
              && (
                <>
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.horizontal[GameTemplate.matrix[x][y].palavra_1.id.toString()][0].chave}
                    </DicaInternaTexto>
                  </DicaInternaContainer>
                  <Divisor />
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.vertical[GameTemplate.matrix[x][y].palavra_2.id.toString()][0].chave}
                    </DicaInternaTexto>
                  </DicaInternaContainer>
                </>
              )}
            {GameTemplate.matrix[x][y].palavra_2.direcao === 0 && GameTemplate.matrix[x][y].palavra_1.direcao === 1
              && (
                <>
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.horizontal[GameTemplate.matrix[x][y].palavra_2.id.toString()][0].chave}
                    </DicaInternaTexto>
                  </DicaInternaContainer>
                  <Divisor />
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.vertical[GameTemplate.matrix[x][y].palavra_1.id.toString()][0].chave}
                    </DicaInternaTexto>
                  </DicaInternaContainer>
                </>
              )}
            {GameTemplate.matrix[x][y].palavra_2.direcao === 0 && GameTemplate.matrix[x][y].palavra_2.direcao === 1
              && (
                <>
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.horizontal[GameTemplate.matrix[x][y].palavra_2.id.toString()][0].chave}

                    </DicaInternaTexto>
                  </DicaInternaContainer>
                  <Divisor />
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.vertical[GameTemplate.matrix[x][y].palavra_2.id.toString()][0].chave}

                    </DicaInternaTexto>
                  </DicaInternaContainer>
                </>
              )}
            {GameTemplate.matrix[x][y].palavra_1.direcao === 1 && GameTemplate.matrix[x][y].palavra_2.direcao === 1
              && (
                <>
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.vertical[GameTemplate.matrix[x][y].palavra_1.id.toString()][0].chave}

                    </DicaInternaTexto>
                  </DicaInternaContainer>
                  <Divisor />
                  <DicaInternaContainer>
                    <DicaInternaTexto zoom={zoomScale}>
                      {GameTemplate.chaves.vertical[GameTemplate.matrix[x][y].palavra_2.id.toString()][0].chave}

                    </DicaInternaTexto>
                  </DicaInternaContainer>
                </>
              )}

            {firstArrowDirection === 'curved_arrow_left' && <ArrowCurvedRight onClick={handleCluePress} src={`${arrowCurvedRight}`} />}
            {firstArrowDirection === 'arrow_bottom' && <ArrowBottom onClick={handleCluePress} src={`${arrow}`} />}
            {firstArrowDirection === 'curved_arrow_bottom' && <ArrowCurvedBottom onClick={handleCluePress} src={`${arrowCurved}`} />}
            {firstArrowDirection === 'arrow_left' && <Arrow onClick={handleCluePress} src={`${arrow}`} />}
            {firstArrowDirection === 'arrow_left_cima' && <ArrowCurvedUp onClick={handleCluePress} src={`${arrowCurvedRight}`} />}
            {firstArrowDirection === 'arrow_bottom_lado' && <ArrowCurvedLeft onClick={handleCluePress} src={`${arrowCurvedLeft}`} />}
            {firstArrowDirection === 'curved_arrow_back' && <ArrowCurvedLeft onClick={handleCluePress} src={`${arrowCurvedLeft}`} />}

            {secondArrowDirection === 'curved_arrow_left' && <ArrowCurvedRight onClick={handleCluePress} src={`${arrowCurvedRight}`} />}
            {secondArrowDirection === 'arrow_bottom' && <ArrowBottom onClick={handleCluePress} src={`${arrow}`} />}
            {secondArrowDirection === 'curved_arrow_bottom' && <ArrowCurvedBottom onClick={handleCluePress} src={`${arrowCurved}`} />}
            {secondArrowDirection === 'arrow_left' && <Arrow onClick={handleCluePress} src={`${arrow}`} />}
            {secondArrowDirection === 'arrow_left_cima' && <ArrowCurvedUp onClick={handleCluePress} src={`${arrowCurvedRight}`} />}
            {secondArrowDirection === 'arrow_bottom_lado' && <ArrowCurvedLeft onClick={handleCluePress} src={`${arrowCurvedLeft}`} />}
            {secondArrowDirection === 'curved_arrow_back' && <ArrowCurvedLeft onClick={handleCluePress} src={`${arrowCurvedLeft}`} />}

          </Container>
        </div>

      );
    }
    return (
      <Container
        isDeadHouse={true}
        houseSize={houseSize}
        isTransparent
      />
    );
  }


  const isRevealed = !!GameState.savedGame.cache.matrix[x]?.[y]?.revelada;

  return (
    <Container
      isSubFocused={GameState.houseStates[x][y].isSubFocused}
      isCorrect={GameState.houseStates[x][y].isCorrect}
      isFocused={GameState.houseStates[x][y].isFocused}
      isRevealed={isRevealed}
      data-revealed={isRevealed}
      houseSize={houseSize}
    >
      <Touch
        onClick={onPressHouse}
        isHighlight={GameState.houseStates[x][y].isHighlight}
        isFocused={GameState.houseStates[x][y].isFocused}

      >
        <InputValue>
          {GameState?.savedGame?.cache?.matrix[x][y]?.letra}
        </InputValue>
      </Touch>
    </Container>

  )
};

export default House;
